class AnonymousCall {
  matchGender = 'random'; //匹配性别 female male random
  state = null; //0准备发起 1匹配中 2通话中 3结束通话 4未接通 5来电中
  times = 0; //次數
  roomUid = null;
  open = false;
  userList = [];
  giftAnimationIndex = null;
  isPlayingAnimation = false;
  allowPlusTimes = true;
  onCall = false; //是否来电中
  user1 = {
    isOpen: false,
    sex: 'female',
    avatar: '',
    name: '匿名用戶',
    score: 0,
    userUuid: null,
    type: 1,
    volume: 0
  };
  user2 = {
    isOpen: true,
    sex: 'male',
    avatar: '',
    name: '我',
    score: 0,
    userUuid: null,
    type: 0,
    volume: 0
  };
  giftRecords = [];
  expireTime = null;
  setOncall(nval) {
    this.onCall = nval;
  }
  //设置匹配性别
  setMatchGender(sex) {
    this.matchGender = sex;
  }
  setState(stateValue) {
    this.state = stateValue;
  }
  setTimes(data) {
    this.times = data.count;
    this.allowPlusTimes = !data.plusCount;
  }
  setRoomUid(roomId) {
    this.roomUid = roomId;
  }

  setExpireTime(expireTime) {
    this.expireTime = expireTime;
  }

  setGiftRecords(giftRecordsValue) {
    if (giftRecordsValue && giftRecordsValue.length) {
      // 倒序数组
      const reversedArr = giftRecordsValue.slice().reverse();
      // 合并数组
      const combinedArr = this.giftRecords.concat(reversedArr);
      // 去重函数

      const uniqueArr = removeDuplicates(combinedArr);
      this.giftRecords = uniqueArr;
    } else {
      this.giftRecords = [];
      this.giftAnimationIndex = null;
      this.isPlayingAnimation = false;
    }
    function removeDuplicates(arr) {
      return arr.reduce((accumulator, currentValue) => {
        if (!accumulator.some(item => item.orderNo === currentValue.orderNo)) {
          accumulator.push(currentValue);
        }
        return accumulator;
      }, []);
    }
  }

  playAnimationEnd() {
    this.giftAnimationIndex =
      this.giftAnimationIndex === null ? 0 : this.giftAnimationIndex + 1;
    this.isPlayingAnimation = false;
  }

  getAnimationUrl() {
    let giftAnimationUrl = '';
    if (this.giftRecords && this.giftRecords.length) {
      let giftAnimationIndex =
        this.giftAnimationIndex === null ? 0 : this.giftAnimationIndex + 1;
      if (giftAnimationIndex < this.giftRecords.length) {
        giftAnimationUrl = this.giftRecords[giftAnimationIndex]
          .giftAnimationUrl;
      }
    }
    return giftAnimationUrl;
  }

  setUsers(users) {
    if (users) {
      const user1Val = users[0] || {
        isOpen: true,
        sex: 'male',
        avatar: '',
        name: '我',
        score: 0,
        userUuid: null,
        type: 0
      };
      const user2Val = users[1] || {
        isOpen: true,
        sex: 'male',
        avatar: '',
        name: '我',
        score: 0,
        userUuid: null,
        type: 0
      };
      const oUser1 = this.user1;
      const oUser2 = this.user2;
      this.user1 = {
        isOpen: user1Val.isAnonymous == 0,
        sex:
          user1Val.sex === 'Female'
            ? 'female'
            : user1Val.sex === 'Male'
            ? 'male'
            : 'random',
        avatar: user1Val.avatarURL,
        name: user1Val.nickname,
        score: user1Val.rankingScore,
        userUuid: user1Val.userUuid,
        type: user1Val.type,
        volume: oUser1.volume
      };
      this.user2 = {
        isOpen: user2Val.isAnonymous == 0,
        sex:
          user2Val.sex === 'Female'
            ? 'female'
            : user2Val.sex === 'Male'
            ? 'male'
            : 'random',
        avatar: user2Val.avatarURL,
        name: user2Val.nickname,
        score: user2Val.rankingScore,
        userUuid: user2Val.userUuid,
        type: user2Val.type,
        volume: oUser2.volume
      };
      this.userList = [this.user1, this.user2];
    } else {
      this.userList = [];
    }
  }

  setOpen(open) {
    this.open = open;
  }

  initData(apiData) {
    const { open, roomUid, expireTime, users, giftRecords } = apiData;
    this.setRoomUid(roomUid);
    this.setGiftRecords(giftRecords);
    this.setUsers(users);
    this.setExpireTime(expireTime);
    this.setOpen(open);
  }
}

const AnonymousCallProvider = new AnonymousCall();
export default AnonymousCallProvider;
